<div class="login-box">
    <div class="title">
        <ng-container *ngIf="formTitle;else defaultTitleTemplate">
            <ng-container *ngIf="formTitleIsTemplate;else stringTitleTemplate">
                <ng-container *ngTemplateOutlet="formTitle">
                </ng-container>
            </ng-container>
            <ng-template #stringTitleTemplate>
                <h3> {{formTitle}}</h3>
            </ng-template>
        </ng-container>
        <ng-template #defaultTitleTemplate>
            <h3>Login</h3>
        </ng-template>
    </div>

    <form [formGroup]="form" (ngSubmit)="login()">
        <nz-form-item>
            <nz-form-control>
                <nz-input-group [nzPrefixIcon]="'user'">
                    <input [formControlName]="'userName'" nz-input [placeholder]="resolveKey('UserName') | translate">

                </nz-input-group>
                <mm-form-error [name]="'userName'" [labelName]="resolveKey('UserName') | translate"></mm-form-error>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-control>
                <nz-input-group [nzPrefixIcon]="'security-scan'">
                    <input type="password" [formControlName]="'password'" nz-input
                        [placeholder]="resolveKey('Password') | translate">
                </nz-input-group>
                <mm-form-error [name]="'password'" [labelName]="resolveKey('Password') | translate"></mm-form-error>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-control>
                <div class="left">
                    <a>{{resolveKey("Register") | translate}}</a>
                </div>
                <div class="right">
                    <a>{{resolveKey("ForgotPassword") | translate}}</a>
                </div>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-control>

                <button type="submit" class="btn-login" [nzType]="'primary'" nz-button>
                    {{resolveKey("Login") | translate}}
                </button>
            </nz-form-control>
        </nz-form-item>
    </form>

</div>